<template>
  <div id="verified">
   

    <div class="card-other">
      <h4>
        尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。
      </h4>
      <div class="main">
        <!-- <p >温馨提示： </p> 
        <br>
        <p>1，所有卡必须完成实名并绑定卡包后方能使用 </p>
        <br>
        <p>2，复制卡号：{{verifiedInfo.iccid}}</p>
        <br>
        <p style="color:red">3，实名完成后请点击卡包绑定卡号</p> -->
        <div class="btnOuter" style="background: #26a2ff">
          <mt-button
           style="background: #26a2ff"
            class="tag-read"
            data-clipboard-action="copy"
            :data-clipboard-text="verifiedInfo.iccid"
            type="primary"
            size="large"
            @click.prevent="sureVerifiedHandler"
            >点击自动复制卡号，去扫码完成实名</mt-button
          >
        </div>
         <div>
             <br/>
               <br/>  
           <!-- <p class="tip">请参考一下实名教程进行实名激活</p>
           <br/>
            <img src="@/assets/kefu/cuccLog.jpg" alt="" class="imgs"> -->
         </div>
       
      </div>
    </div>
    <!-- 图片实名认证 -->
		<van-dialog v-model="showimg" title="请扫描下方二维码实名" show-cancel-button  @confirm="confirmn">
      <!-- <wx-open-launch-weapp id="launch-btn" username="gh_5eac63f4d504" path=""> -->
        <img style="width:100%;" src="@/assets/suolangunicom.jpg" />
    <!-- </wx-open-launch-weapp> -->
		</van-dialog>
  </div>
</template>
<script>
import Clipboard from 'clipboard';
import { wxRequest, verified } from "@/api/user";
import { Toast,Dialog } from 'vant';
import wx from 'weixin-js-sdk';
export default {
  data() {
    return {
      qianhairealname:false,
      state: "",
      supplierTypeCode: "",
      verifiedInfo: {
        iccid: localStorage.getItem('iccid'),
        name: "张三",
        userPhone: "",
        idcard: "41152819960319589X",
        code:null
      },
      disabledFlag: false,
      existFrontImg: false,
      existBackImg: false,
      existHandImg: false,
      frontImgUrl: "",
      backImgUrl: "",
      handImgUrl: "",
      realNameCard: -1, //需弹实名的卡
      isFirst: 0,
      showimg:false
    };
  },
  methods: {
    sureVerifiedHandler() {
       var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
          clipboard.destroy()// 释放内存
       })
      // this.showimg=true;
      Toast.fail('卡号复制成功');
    },
    confirmn(){
      wxRequest("sim/getWxConfig1", {}, "post").then(res => {         
        if(res.data.code == 200){
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr:res.data.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.data.signature,// 必填，签名
            jsApiList: [
              'onMenuShareAppMessage', // 分享给朋友
              'onMenuShareTimeline', // 分享到朋友圈
              'onMenuShareQQ', // 分享到QQ
              'onMenuShareQZone', // 分享到QQ空间
            ], // 必填，需要使用的JS接口列表
            // openTagList: [ 'wx-open-launch-weapp'] 
          }); 
          wx.ready(function() {
          	wx.onMenuShareAppMessage({
              title:'测试数据', // 分享标题
              desc: '12312312312', // 分享描述
              link: 'https://www.baidu.com', // 分享链接
              imgUrl: 'https://h5.kehu.fun/static/img/2.jpg', // 必须是https网络路径,不能大于20kb
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function () {
                Toast.fail('分享成功');
              }
            })
          });
        }
      })
    },
  },
  created() {
  
  },

  mounted() {
    
  },
};
</script>
<style lang="less">
#verified {


  height: 100%;
  .imgs{
    width: 100%;
    height: 100%;
   
  }
  .tip{
            color: red;
            text-align: center;
            margin-top: 10px;
            font-size:16px;
            margin-bottom:24px;
       }
  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }
  ul {
        margin: 10px;
        li {
            line-height: 36px;
            padding: 3px 0;
            border-bottom: 1px solid #ffa33a;
            svg {
                vertical-align: middle;
                margin-right: 8px;
            }
            .codeBtn {
                float: right;
                margin-top: 2px;
            }
        }
    }
  .main {
    height: calc(100% - 48px);
    padding: 0 4%;
    form {
      height: 100%;
    }
    .line {
      border-bottom: 1px solid #e5e5e5;
    }
    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)
      background: #26a2ff;

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;
    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }
    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }
  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}
</style>
